import React from 'react';
import Header from '../Header/Header';
import Watchlist from '../Watchlist/Watchlist';

const WatchlistStock = () => { 
    return(
        <>
        <Header/>
        <div className="container mt-5">
            <div className="row">
                <div className="col-md-8 mx-auto mt-5">
                <Watchlist />
                </div>
            </div>
        </div>
        </>
    )
}

export default WatchlistStock;